import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export default function RedactedPill() {
  return (
    <Box
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.semantic.spacing.xs,
        px: theme.semantic.spacing.xs,
        py: theme.semantic.spacing['3xs'],
        borderRadius: '6.25rem',
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.text.secondary,
      })}
    >
      <LockOutlinedIcon
        sx={(theme) => ({
          fontSize: theme.semantic.fontSize.sm,
        })}
      />
      <Typography
        variant="button"
        sx={(theme) => ({
          fontSize: theme.semantic.fontSize.xs,
          letterSpacing: theme.semantic.letterSpacing.lg,
        })}
      >
        Redacted
      </Typography>
    </Box>
  );
}
